import { render, staticRenderFns } from "./blessingDragon.vue?vue&type=template&id=4710a0b2&scoped=true"
import script from "./blessingDragon.vue?vue&type=script&lang=js"
export * from "./blessingDragon.vue?vue&type=script&lang=js"
import style0 from "./blessingDragon.vue?vue&type=style&index=0&id=4710a0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710a0b2",
  null
  
)

export default component.exports